module.exports = __webpack_public_path__ + "img/success.b3bf1d07.svg";